import { Injectable } from '@angular/core';
import { filter, fromEvent, switchMap, tap } from 'rxjs';
import { createEffect } from '@ngrx/effects';
import { NewAppVersionService, ssmNewAppVersionEventName } from '@vpfa/environments/data';
import { ModalService } from '@vpfa/modals';

@Injectable()
export class NotificationsEffects {
  constructor(
    private modalService: ModalService,
    private newAppVersionService: NewAppVersionService,
  ) {}

  showNotificationAboutNewAppVersion$ = createEffect(
    () => {
      return fromEvent(document, ssmNewAppVersionEventName).pipe(
        switchMap(() =>
          this.modalService.confirm(
            ['newAppVersion.infoAboutNewVersion'],
            'newAppVersion.yesRestart',
            'newAppVersion.doNotRestart',
            'info',
            'appRestartConfirm',
          ),
        ),
        filter(restart => restart === true),
        tap(() => {
          this.newAppVersionService.restartApp();
        }),
      );
    },
    { dispatch: false },
  );
}
